import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./styles.css";

const BackToHome = () => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="back-to-home"
      onClick={() => navigate("/muscleUp")}
    >
      <ArrowBackIcon />
      <span>BACK TO HOME</span>
    </button>
  );
};

export default BackToHome;
